var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:['mouse', _vm.theme],attrs:{"src":_vm.src,"alt":"滑动提示"}})
}
var staticRenderFns = []

export { render, staticRenderFns }